function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  gradientUnits: "userSpaceOnUse",
  x1: 487.02,
  x2: -24.332,
  y1: 487.02,
  y2: -24.332
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2884a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f2c94c"
}));

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  gradientUnits: "userSpaceOnUse",
  x1: 317.027,
  x2: -20.418,
  y1: 225.733,
  y2: -111.713
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2c94c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.268,
  stopColor: "#f2c34c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.627,
  stopColor: "#f2b24b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f2994a"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m408 386h-304a40.045 40.045 0 0 1 -40-40v-180a40.045 40.045 0 0 1 40-40h304a40.045 40.045 0 0 1 40 40v180a40.045 40.045 0 0 1 -40 40z",
  fill: "url(#linear-gradient)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m256 272.1a68.6 68.6 0 0 1 -31.373-7.577l-155.2-79.823a10 10 0 0 1 -5.427-8.89v-9.81a40.045 40.045 0 0 1 40-40h304a40.045 40.045 0 0 1 40 40v9.81a10 10 0 0 1 -5.427 8.893l-155.2 79.82a68.6 68.6 0 0 1 -31.373 7.577z",
  fill: "url(#linear-gradient-2)"
});

var SvgMessage = function SvgMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    "data-name": "Layer 1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message.71b47bdc.svg";
export { ForwardRef as ReactComponent };